module.exports = __webpack_public_path__ + "img/tg.c9b912ea.svg";